import { Component, DoCheck, EventEmitter, Inject, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild, ChangeDetectorRef, ChangeDetectionStrategy, inject } from '@angular/core';
import { catchError, forkJoin, of, Subject, takeUntil } from 'rxjs';
import { Applications, ISignal, RolePermissionsModel } from '../../../../shared/models/app.model';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AdvancedSearchEmployeesConfigurations, GENERAL_UI, PreferencesConfigurationssModel, PROFILE_SOURCES, profileModificationModel, SERVICES_UI, UPEnums, UPGeneralFields, UPServiceFields } from '../../model/user-profile.model';
import { UserProfileService } from '../../services/user-profile.service';
import { CommonService } from '../../../../shared/services/common.service';
import { Grid, GridConfig, GridRowsSelectedEvent } from '@inavista/components/grid';
import { LOCAL_ROWS_URL, LocalRowsGridApi, provideLocalGridRows } from 'projects/service/src/app/shared/utils/local-rows-grid-api';
import { REGEXES, UserRoles } from '../../../../shared/constants/app.constants';
import { CheckBoxComponent } from '@syncfusion/ej2-angular-buttons';
import { DataManager, ODataV4Adaptor, Predicate, Query } from '@syncfusion/ej2-data';
import { AuthService } from 'projects/sales/src/app/core/services/auth/auth.service';
import { ComboBoxComponent, DropDownList } from '@syncfusion/ej2-angular-dropdowns';
import { APP_CONFIG, AppConfig } from 'projects/shared/src/lib/app-config.token';
import { UploaderComponent } from '@syncfusion/ej2-angular-inputs';
import { DroApiService } from 'projects/shared/src/lib/dro/dro-api.service';
import { DroSetupPermission } from 'projects/shared/src/lib/dro/dro.models';

let MASTER_API_URL = '';
const SERVICE_DEPTS_URL = `${LOCAL_ROWS_URL}user-profile/service-departments`;
@Component({
    selector: 'app-up-rims-service',
    templateUrl: './up-rims-service.component.html',
    styleUrls: ['./up-rims-service.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    // The Additional Service Depts grid's rows are the section's own (LocalRowsGridApi); the search popups reach the server.
    providers: [...provideLocalGridRows()],
    standalone: false
})
export class UpRimsServiceComponent implements OnInit, OnChanges, DoCheck {
  private loggedInUser = null;
  UserRoles: typeof UserRoles = UserRoles;
  UPEnums: typeof UPEnums = UPEnums;
  Validators: typeof Validators = Validators;
  userId: string = '';
  // "Can Setup DRO Forms" (docs/DRO 8.1): rendered and editable as RIMS Master api/dro/setup-permission says
  // (app.rolePermissions for the editor and the edited user's role); written with the section's Save.
  droSetup: DroSetupPermission | null = null;
  droSetupValue = false;
  private droSetupChanged = false;
  private readonly droApi = inject(DroApiService);
  @Input('reloadSection') reloadSection: boolean = false;
  @Output() sendProfileDataToParent = new EventEmitter<any>();
  isRoleChanged: boolean = false;
  // expandServiceSection: boolean = false;
  isCreatingNewUser: boolean = false;
  UserProfileService: typeof UserProfileService = UserProfileService;
  isSectionEnabled: boolean = false;
  employeeId: string = '';
  dataFieldsWithEmployeeId = [
    // UPServiceFields.employeeId,
    UPServiceFields.email,
    UPServiceFields.mobile,
    UPServiceFields.serviceCar,
    UPServiceFields.warehouse,
    UPServiceFields.name,
    UPServiceFields.address,
    UPServiceFields.city,
    UPServiceFields.state,
    UPServiceFields.country,
    UPServiceFields.zipCode,
    UPServiceFields.iscCode,
    UPServiceFields.t1LaborRate,
    UPServiceFields.mileageRate,
    UPServiceFields.t2LaborRate,
    UPServiceFields.mileageThreshold,
    UPServiceFields.t1CalloutRate,
    UPServiceFields.t2CalloutRate,
    UPServiceFields.iscSupplierCode,
    UPServiceFields.addressCode,
    UPServiceFields.iscManager,
    UPServiceFields.payViaInt,
    UPServiceFields.serviceDept
  ];
  
  
  newAddress: any;
  initiallyHasNoEmployeeId: boolean;
  isAdminLoggedIn: boolean;
  showISCManagerHyperlink: boolean = false;
  isISCManagerLoggedIn: boolean;
  deptsGrid?: Grid;
  @ViewChild('logoUpload') public uploader!: UploaderComponent;
  @ViewChild('payViaDDL') public payViaDDL!: DropDownList;
  @ViewChild('partsOfficeDDL') public partsOfficeDDL!: DropDownList;
  @ViewChild('employeeIdCombo') public employeeIdCombo!: ComboBoxComponent;
  @ViewChild('sdDDL') public sdDDL!: DropDownList;
  @ViewChild('serviceEnableCb') public serviceEnableCb!: CheckBoxComponent;
  pictureURL: string = '';
  path: { saveUrl: string; removeUrl: string; };
  mobileEmailAddressAssignedToGeneralOnce: boolean = false;
  markAddressToBeCopiedToGeneral: boolean;
  // The grid shows once the permissions are in (@if): tick its rows then.
  @ViewChild('deptsGrid') set gridC(grid: Grid | undefined) {
    const appeared = !!grid && grid !== this.deptsGrid;
    this.deptsGrid = grid;
    if (appeared) this.tickDepts();
  }
  // Additional Service Depts: a ticked list of the section's own rows (LocalRowsGridApi), saved with the profile.
  readonly deptsGridConfig: GridConfig = {
    apiBaseUrl: SERVICE_DEPTS_URL,
    keyColumn: 'id',
    clientSide: true,
    rowHeight: 26,
    stretchColumns: true,
    enableToolbar: false,
    enableFiltering: false,
    selectable: true,
    rowCheckLockedFn: () => (!this.isSectionEnabled ? 'This section is disabled'
      : !this.getPermission('Service_additionalServiceDeptsList')?.enable || !!this.getPermission('Service_additionalServiceDeptsList')?.readOnly
        ? 'Your role cannot change the additional service departments' : false),
    defaultColumnOrder: ['serviceDepartment'],
    hiddenByDefaultColumns: ['id', 'description'],
    columnLabels: { serviceDepartment: UPServiceFields.additionalServiceDepartmentsDesc },
    columnAlign: { serviceDepartment: { header: { horizontal: 'left' } } },
    // As before: the department and its description.
    columnFormatters: { serviceDepartment: (_value, row) => `${row['serviceDepartment'] ?? ''} - ${row['description'] ?? ''}` },
    emptyStateMessage: 'No service departments to choose from.',
    persistenceKey: 'rims.users.service-departments',
    persistenceVersion: 1,
  };
  private readonly deptRows = inject(LocalRowsGridApi);
  private shownDepts: any[] | null = null;
  private shownDeptTicks = '';
  private shownDeptIds = '';
  private shownDeptsEnabled: boolean | null = null;
  isEmpty(strValue: string): boolean {
    return typeof (strValue) === 'string' && strValue.trim() === '';
  }
  /**
   * will assign ISCManagerData if it is passed in parameter, else will just reset the fields.
    */
  assigneISCManagerDetailsToISC(ISCManagerData?: string) {
    if (ISCManagerData) {
      this.usersService.getServicesUserById(ISCManagerData[UPServiceFields.userId]).subscribe({
        next: (res: any) => {
      const ISCManagerData = res?.result as any[];
      [
        UPServiceFields.laborType,
        UPServiceFields.laborTask,
        UPServiceFields.iscCode,
        UPServiceFields.laborCCMP,
        UPServiceFields.otherCCMP,
        'travelCalloutCharges',
        UPServiceFields.materialCCMP,

        UPServiceFields.iscSupplierCode,
        UPServiceFields.payViaInt,
        UPServiceFields.partsSalesOfficeInt,
        // UPServiceFields.email,
        // UPServiceFields.mobile, 
        UPServiceFields.serviceDept,
        UPServiceFields.serviceManager,

        UPServiceFields.name,
        UPServiceFields.addressCode,
        UPServiceFields.address,
        UPServiceFields.city,
        UPServiceFields.state,
        UPServiceFields.zipCode,
        UPServiceFields.country,

        UPServiceFields.mileageThreshold,
        UPServiceFields.t1LaborRate,
        UPServiceFields.t2LaborRate,
        UPServiceFields.t1CalloutRate,
        UPServiceFields.t2CalloutRate,
        UPServiceFields.mileageRate,
      ].forEach((c: string) => {
        let val = ISCManagerData[c];
        typeof (val) == 'string' && val.trim();
        this.serviceForm.controls[c].setValue(val);
        if(c == UPServiceFields.iscCode) {
          this.serviceForm.controls[c].setValue(ISCManagerData['iscCode'] + " - " + ISCManagerData['iscBPName']);
        }
        if(c == UPServiceFields.serviceDept) {
          !val && this.sdDDL?.clear();
          !!val && this.serviceForm.controls[c].setValue(val?.split(' ')[0]);
        }
        this.serviceForm.controls[c].updateValueAndValidity();
        this.sectionModified({modified: true, section: UPEnums.ServicesFormData}, "assigneISCManagerDetailsToISC");
      });
      // this.nullCheckPayload();
      this.serviceForm.get(UPServiceFields.iscManager).setValue(ISCManagerData['userId'] + " - " + ISCManagerData['employeeName']);
      this.serviceForm.get(UPServiceFields.iscManager).updateValueAndValidity();
      // this.serviceForm.get(UPServiceFields.payViaInt).setValue(ISCManagerData['payVia']);
      // this.serviceForm.get(UPServiceFields.payViaInt).updateValueAndValidity();


      this.sectionModified({modified: true, section: UPEnums.ServicesFormData}, "assigneISCManagerDetailsToISC");


      if (this.hasAddress) {
          this.newAddress = {
            "addressCode": ISCManagerData[UPServiceFields.addressCode],
            "name": ISCManagerData[UPServiceFields.name],
            "address": ISCManagerData[UPServiceFields.address],
            "address2": ISCManagerData[UPServiceFields.address2],
            "houseNumber": ISCManagerData[UPServiceFields.houseNumber],
            "postBoxNumber": ISCManagerData[UPServiceFields.postBoxNumber],
            "city": ISCManagerData[UPServiceFields.city],
            "stateProvince": ISCManagerData[UPServiceFields.state] ?? ISCManagerData["stateProvince"],
            "country": ISCManagerData[UPServiceFields.country],
            "countryId": ISCManagerData[UPGeneralFields.countryId],
            "zipCode": ISCManagerData[UPServiceFields.zipCode],
            "telephone": ISCManagerData[UPServiceFields.mobile],
            "isDefault": false,
            "isLNPreferred": false,
            "isDeleted": false
          };
        }
        if (
          !!ISCManagerData['email'] ||
          !!ISCManagerData['telephone'] ||
          !!ISCManagerData['address'] ||
          !!ISCManagerData['address2'] ||
          !!ISCManagerData['addressCode']) {
            // this.copyDataToGeneral();
          this.markAddressToBeCopiedToGeneral = true;
          }
        }
      })
    } else {
      [
      UPServiceFields.iscCode,
      UPServiceFields.iscManager,
      UPServiceFields.iscSupplierCode,


      UPServiceFields.email,
      UPServiceFields.mobile,
      UPServiceFields.serviceDept,
      UPServiceFields.serviceManager,

      ].forEach((c) => this.serviceForm.controls[c].setValue(''));
      this.sdDDL?.clear();
      this.serviceForm.controls[UPServiceFields.laborType].setValue('');
      this.serviceForm.controls[UPServiceFields.laborTask].setValue('');
      this.serviceForm.controls[UPServiceFields.laborCCMP].setValue('');
      this.serviceForm.controls[UPServiceFields.otherCCMP].setValue('');
      this.serviceForm.controls['travelCalloutCharges'].setValue('');
      this.serviceForm.controls[UPServiceFields.materialCCMP].setValue('');
      [
        UPServiceFields.payViaInt,
        UPServiceFields.mileageThreshold,
        UPServiceFields.t1LaborRate,
        UPServiceFields.t2LaborRate,
        UPServiceFields.t1CalloutRate,
        UPServiceFields.t2CalloutRate,
        UPServiceFields.partsSalesOfficeInt,
        UPServiceFields.mileageRate,
      ].forEach((c) => this.serviceForm.controls[c].setValue(0));

    }
    this.sectionModified({modified: true, section: UPEnums.ServicesFormData}, "assigneISCManagerDetailsToISC");
  }
  onFilteringEmployeeId(args: any) {
  // let query = new Query().take(20);
  if(args.text) {
    const searchText = args.text?.toLowerCase() ?? '';
    
      const filtered = this.employeeIdsData.filter(emp =>
        emp.employeeId?.toString().toLowerCase().includes(searchText) ||
        emp.employeeName?.toString().toLowerCase().includes(searchText)
      );
    
      this.employeeIdsDataSource = filtered;
  } else {
    this.employeeIdsDataSource = this.employeeIdsData;
  }
  // if (e.text) {
  //   // const prd = new Predicate('employeeId', 'startsWith', e.text, true).or('employeeName', 'startsWith', e.text, true)
  //   // query = query.where(prd);
  // }

  // e.updateData(this.employeeIdsData, query);
}
  onEmployeeIdChange(e: any, data: any) {
    const upRole = this.serviceForm.controls[UPServiceFields.role]?.value;
    if (e?.isInteracted) {

      this.employeeIdsDataSource = this.employeeIdsData; // reset datasource on each change to avoid confusion in filtering after selection



      if (data) {
        data = Object.fromEntries(
          Object.entries(data).map(([key, value]) => [
            key,
            typeof value === 'string' ? value.trim() : value
          ])
        );
        this.serviceForm.controls[UPServiceFields.employeeId].setValue(data[UPServiceFields.employeeId]);

        // just added these 3 fields serviceCar, serviceManager, warehouse
        this.serviceForm.controls[UPServiceFields.serviceCar].setValue(data['serviceCar']);
        this.serviceForm.controls[UPServiceFields.serviceManager].setValue(data['serviceManager']);
        this.serviceForm.controls[UPServiceFields.warehouse].setValue(data['warehouse']);

        this.serviceForm.controls[UPServiceFields.email].setValue(data[UPServiceFields.email]);
        this.serviceForm.controls[UPServiceFields.mobile].setValue(data['telephone']);
        if(upRole != UserRoles.iscManager) { 
          this.serviceForm.controls[UPServiceFields.name].setValue(data['name']);
          this.serviceForm.controls[UPServiceFields.addressCode].setValue(data['addressCode']);
          this.serviceForm.controls[UPServiceFields.address].setValue(data['address']);
          this.serviceForm.controls[UPServiceFields.city].setValue(data['city']);
          this.serviceForm.controls[UPServiceFields.state].setValue(data['stateProvince'] ?? data[UPServiceFields.state]);
          this.serviceForm.controls[UPServiceFields.zipCode].setValue(data['zipCode']);
          this.serviceForm.controls[UPServiceFields.country].setValue(data['country']);
        }

        
        if(data?.serviceDepartment) {
          data.serviceDepartment = data?.serviceDepartment?.split(' ')[0];
          const i = this.serviceDeptsDataDDL.findIndex(fi => fi.serviceDepartment == data?.serviceDepartment);
          switch (i) {
            case -1: // no match found in department list, just append in depts DDL
              this.serviceDeptsDataDDL = [...this.serviceDeptsDataDDL, {
                serviceDepartment: data?.serviceDepartment,
                description: data?.serviceDepartmentName
              }];
              break;
          
            default: // match found in department list, remove from the additional dept
            const index = this.additionalServiceDeptsData.findIndex(fi => fi?.serviceDepartment == data?.serviceDepartment);
            if (index > -1) {
              const updated = [...this.additionalServiceDeptsData];
              updated.splice(index, 1);
              this.additionalServiceDeptsData = updated;
            }
              break;
          }
          this.serviceForm.controls[UPServiceFields.serviceDept].setValue(data?.serviceDepartment); 
        } else {
          this.serviceForm.controls[UPServiceFields.serviceDept].setValue('');
          this.sdDDL?.clear();
        }
        if (this.hasAddress && upRole != UserRoles.iscManager) {
          this.newAddress = {
            "addressCode": data[UPServiceFields.addressCode],
            "name": data[UPServiceFields.name],
            "address": data[UPServiceFields.address],
            "address2": data[UPServiceFields.address2],
            "houseNumber": data[UPServiceFields.houseNumber],
            "postBoxNumber": data[UPServiceFields.postBoxNumber],
            "city": data[UPServiceFields.city],
            "stateProvince": data[UPServiceFields.state] ?? data["stateProvince"],
            "country": data[UPServiceFields.country],
            "countryId": data[UPGeneralFields.countryId],
            "zipCode": data[UPServiceFields.zipCode],
            "telephone": data[UPServiceFields.mobile],
            "isDefault": false,
            "isLNPreferred": false,
            "isDeleted": false
          };
        }
        if (
          !!data['email'] ||
          !!data['telephone'] ||
          !!data['address'] ||
          !!data['address2'] ||
          !!data['addressCode']) {
            // upRole != UserRoles.iscManager && this.copyDataToGeneral();
            upRole != UserRoles.iscManager && (this.markAddressToBeCopiedToGeneral = true); // set a flag to copy data to general after employee id selection, this is to avoid multiple popups in case of multiple field changes on employee id selection
          }
      } else {
        // this.serviceForm.get(UPServiceFields.payVia).setValue(0);
        this.resetControl([
          // UPServiceFields.employeeId,
          UPServiceFields.email,
          UPServiceFields.mobile,
          UPServiceFields.name,
          UPServiceFields.addressCode,
          UPServiceFields.address,
          UPServiceFields.city,
          UPServiceFields.state,
          UPServiceFields.country,
          UPServiceFields.zipCode,
          UPServiceFields.serviceDept,
          UPServiceFields.serviceCar,
          UPServiceFields.warehouse,
          UPServiceFields.serviceManager,
          // UPServiceFields.iscCode,
          // UPServiceFields.iscSupplierCode,
          // UPServiceFields.t1LaborRate,
          // UPServiceFields.mileageRate,
          // UPServiceFields.t2LaborRate,
          // UPServiceFields.mileageThreshold,
          // UPServiceFields.t1CalloutRate,
          // UPServiceFields.t2CalloutRate
        ]);
        this.sdDDL?.clear();
      }
      this.sectionModified({modified: true, section: UPEnums.ServicesFormData}, 'onEmployeeIdChange');
    }
  }
  onISCCodeSelected(e: any) {
    let data = e.itemData ?? e;
  if(data) {
    data && this.serviceForm.patchValue(data);
    this.serviceForm.get(UPServiceFields.iscCode)?.setValue(e?.soldToBP + ' - ' + e?.name);
    this.serviceForm.get(UPServiceFields.state)?.setValue(e?.stateProvince);
    this.serviceForm.get(UPServiceFields.mobile)?.setValue(e?.telephone);

    
    if (this.hasAddress) {
      this.newAddress = {
        "addressCode": data[UPServiceFields.addressCode],
        "name": data[UPServiceFields.name],
        "address": data[UPServiceFields.address],
        "address2": data[UPServiceFields.address2],
        "houseNumber": data[UPServiceFields.houseNumber],
        "postBoxNumber": data[UPServiceFields.postBoxNumber],
        "city": data[UPServiceFields.city],
        "stateProvince": data[UPServiceFields.state] ?? data["stateProvince"],
        "country": data[UPServiceFields.country],
        "countryId": Number(data[UPGeneralFields.countryId]),
        "zipCode": data[UPServiceFields.zipCode],
        "telephone": data[UPServiceFields.mobile],
        "isDefault": false,
        "isLNPreferred": false,
        "isDeleted": false
      };
    }
    if (
      !!data['email'] ||
      !!data['telephone'] ||
      !!data['address'] ||
      !!data['address2'] ||
      !!data['addressCode']) {
        // this.copyDataToGeneral();
        this.markAddressToBeCopiedToGeneral = true; // set a flag to copy data to general after ISC code selection, this is to avoid multiple popups in case of multiple field changes on ISC code selection
      }
      this.sectionModified({modified: true, section: UPEnums.ServicesFormData}, 'onISCCodeSelected');

    }
  }
  employeeIdsData: any[] = [];
  employeeIdsDataSource: any[] = [];
  advancedSearchEmployeesConfigurations: AdvancedSearchEmployeesConfigurations;
  additionalServiceDeptsData: any[] = [];
  serviceDeptsDataDDL: any[] = [];
  payViaData: any;
  partsOfficeData: any;



  onRolesChange(e: any) {
    const roleId = e?.itemData?.displayOrder;
    const role = e?.itemData?.role;
    const isPreviousRoleISCorISCSupervisor: boolean  = ([UserRoles.isc, UserRoles.IscSupervisor].includes(this.serviceForm.controls?.[UPServiceFields.role]?.value));
    if (roleId) {
      this.serviceForm.controls?.[UPServiceFields.roleId]?.setValue(roleId);
    }
    if (e?.isInteracted) {
      // this.dataFieldsWithEmployeeId.forEach(c => {
      //   this.resetFieldValue(c);
      //   this.serviceForm.controls[c].updateValueAndValidity();
      // });
      let iscMgrControl = this.serviceForm.controls[UPServiceFields.iscManager];
      this.isRoleChanged = !!this.serviceForm.controls[UPServiceFields.role].value;
      this.servicePreferencesConfig.hasRoleIdChanged = this.isRoleChanged;

      const isRoleChangedToISC = e?.itemData?.role == UserRoles.isc || e?.itemData?.role == UserRoles.IscSupervisor;

      if (isRoleChangedToISC) { // should happen if ISC Manager is creating profile or changing role to an ISC.
        //fetch managers details and assign the rates from manager's to isc.
        this.showISCManagerHyperlink = true;

        if (this.isISCManagerLoggedIn) {
          if (!this.mobileEmailAddressAssignedToGeneralOnce) {
            this.assigneISCManagerDetailsToISC(this.loggedInUser);
            iscMgrControl.setValue(this.commonService.getUserId() + ' - ' + this.commonService.getUSER()?.firstName);
          }
        } else {
          this.assigneISCManagerDetailsToISC(); // this will reset the data for isc/isc supervisor
        }
        // this.serviceForm.controls[UPServiceFields.laborType]?.setValue(USER?.[UPServiceFields.laborType] ?? '');
        // this.serviceForm.controls[UPServiceFields.laborTask]?.setValue(USER?.[UPServiceFields.laborTask] ?? '');
        // this.serviceForm.controls[UPServiceFields.serviceDept]?.setValue(USER?.[UPServiceFields.serviceDept] ?? '');
        // this.serviceForm.controls[UPServiceFields.iscCode]?.setValue(USER?.[UPServiceFields.iscCode] ?? '');
        // this.serviceForm.controls[UPServiceFields.payVia]?.setValue(USER?.[UPServiceFields.payVia] ?? 0);
        // this.serviceForm.controls[UPServiceFields.mileageThreshold]?.setValue(USER?.[UPServiceFields.mileageThreshold] ?? 0);
        // this.serviceForm.controls[UPServiceFields.t1LaborRate]?.setValue(USER?.[UPServiceFields.t1LaborRate] ?? 0);
        // this.serviceForm.controls[UPServiceFields.t2LaborRate]?.setValue(USER?.[UPServiceFields.t2LaborRate] ?? 0);
        // this.serviceForm.controls[UPServiceFields.t1CalloutRate]?.setValue(USER?.[UPServiceFields.t1CalloutRate] ?? 0);
        // this.serviceForm.controls[UPServiceFields.t2CalloutRate]?.setValue(USER?.[UPServiceFields.t2CalloutRate] ?? 0);
        // this.serviceForm.controls[UPServiceFields.mileageRate]?.setValue(USER?.[UPServiceFields.mileageRate] ?? 0);
        // this.serviceForm.controls[UPServiceFields.laborCCMP]?.setValue(USER?.[UPServiceFields.laborCCMP] ?? '');
        // this.serviceForm.controls[UPServiceFields.otherCCMP]?.setValue(USER?.[UPServiceFields.otherCCMP] ?? '');
        // this.serviceForm.controls[UPServiceFields.materialCCMP]?.setValue(USER?.[UPServiceFields.materialCCMP] ?? '');
        this.resetAdditionalServiceDepartmentsAPI();
      } else {
        this.showISCManagerHyperlink = false;

        // check if we are switching out of isc/isc sup role, then reset the 
        
        
        isPreviousRoleISCorISCSupervisor &&  this.assigneISCManagerDetailsToISC(); // this will reset the data for isc/isc supervisor
      }
      // this.employeeId = null;
      // this.serviceForm.controls[UPServiceFields.employeeId].enable();
      // this.serviceForm.get(UPServiceFields.employeeId).reset("");

      this.sectionModified({
        modified: true,
        section: UPEnums.ServicesFormData,
        updatedPermissiosParameters: {
          category: this.source == UPEnums.SourceMyProfile ? UPEnums.MPServicePermission : UPEnums.UPServicePermission,
          id: this.source == UPEnums.SourceMyProfile ? '' : this.userId,
          subCategory: role
        }
      }, 'onRolesChange');
      iscMgrControl.updateValueAndValidity();
      this.pictureURL = '';
    }
    this.serviceForm.controls?.[UPServiceFields.roleId]?.setValue(e?.itemData?.displayOrder ?? '');
    this.serviceForm.controls?.[UPServiceFields.role]?.setValue(role ?? '');
    this.serviceForm.controls?.[UPServiceFields.userId]?.setValue(this.userId);
    ([UserRoles.fst].includes(this.serviceForm.controls?.[UPServiceFields.role]?.value)) && this.assignDefaultFSTValues();
    role !== UserRoles.rimsCsa && this.serviceForm.controls?.[UPServiceFields.canCompleteClaims]?.setValue(false); // CSA-only flag
    if (([UserRoles.rimsCsa, UserRoles.salesCsa, UserRoles.conwayServiceManager, UserRoles.rimsReadOnly, UserRoles.salesReadOnly].includes(role))) { 
      this.serviceForm.controls?.[UPServiceFields.serviceDept]?.setValue('');
      this.sdDDL?.clear();
    }
    this.cdRef.markForCheck();
  }
  // Lets a CSA complete/reject In Progress claims even when a business rule fails. Only Admins and Service Managers
  // can grant it, so a CSA can't give it to themselves from their own profile.
  get canEditCanCompleteClaims(): boolean {
    return [UserRoles.administratorRole, UserRoles.conwayServiceManager].includes(this.loggedInUser?.role) && this.isSectionEnabled;
  }
  resetControl(controls: UPServiceFields[], value: any = ""): void {
    controls.forEach(f => {
      this.serviceForm.controls[f].setValue(value);
      this.serviceForm.controls[f].updateValueAndValidity();
    })
  }
  resetFieldValue(c: UPServiceFields): void {
    if (c == UPServiceFields.mileageThreshold || c == UPServiceFields.t2CalloutRate || c == UPServiceFields.t1CalloutRate || c == UPServiceFields.t2LaborRate || c == UPServiceFields.t1LaborRate || c == UPServiceFields.mileageRate) {
      this.serviceForm.get(c)?.reset(0);
    } else {
      // // check if the user is created with employeeId, do not reset the employeeId then
      // (!this.employeeId || c != UPServiceFields.employeeId) && this.serviceForm.get(c)?.reset("");
      this.serviceForm.get(c)?.reset("");
    }
    this.serviceForm.markAsPristine();
  }
  @Input('userProfile') userProfile: any;
  @Input('source') source: PROFILE_SOURCES = UPEnums.SourceUser;
  PERMISSIONS: RolePermissionsModel[] = [];




  @Input() actions: Subject<ISignal> = new Subject();
  action: Subject<ISignal>;

  @Output() profileModified = new EventEmitter<profileModificationModel>();

  UPServiceFields: typeof UPServiceFields = UPServiceFields;
  serviceForm: FormGroup<any>;
  private destroy$: Subject<any>;
  isFormSubmitted: boolean = false;
  modifiedUI: any = {};

  todayDate: Date = new Date(Date.now());
  servicePreferencesConfig!: PreferencesConfigurationssModel;
  showAdvancedEmployeesSearchPopup: boolean = false;
  // showAdvancedISCEmployeesPopup: boolean = false;
  showAdvancedISCCodePopup: boolean = false;
  rolesData: any;


  constructor(
    @Inject(APP_CONFIG) private config: AppConfig,
    private fb: FormBuilder, 
    private usersService: UserProfileService, 
    private commonService: CommonService, 
    private authService: AuthService,
    private cdRef: ChangeDetectorRef
  ) {
    MASTER_API_URL = this.config.masterApiURL;
    this.path = {
    saveUrl: `${MASTER_API_URL}FileManagement/UploadTemp`,
    removeUrl: 'https://ej2.syncfusion.com/services/api/uploadbox/Remove'
  };
    this.modifiedUI[UPEnums.ServicesFormData] = false;
    this.modifiedUI[UPEnums.ServicesBusinessLogo] = false;
    this.modifiedUI[UPEnums.ServicePreferencesData] = false;
    this.userProfile = { userId: '' };
    this.action = new Subject();
    this.serviceForm = this.fb.group({});
    this.actions = new Subject();
    this.destroy$ = new Subject();
    this.advancedSearchEmployeesConfigurations = {
      fetchIdsFor: 'service-employeeIds',
      popupTitle: "Advanced Employees Search",
    };
  }
  ngOnChanges(changes: SimpleChanges): void {
    changes?.['reloadSection'] && changes?.['reloadSection'].currentValue == true && this.getServicesData();
  }

  ngOnInit() {
    this.fetchLoggedInUser();
    this.userId = this.userProfile?.[UPServiceFields.userId];
    this.isCreatingNewUser = (!this.userId && this.source == UPEnums.SourceUser);
    this.initForm();
    this.loadPermissions(true);
    this.loadDroSetup();
    if (!this.isCreatingNewUser) {
      this.servicePreferencesConfig = { apiEndPoint: '', gridId: 'service-preferences', gridName: 'service-preferences-grid', userId: this.source == UPEnums.SourceMyProfile ? '' : this.serviceForm.controls[UPServiceFields.userId]?.value, appName: Applications.RimsService, roleId: this.userProfile?.roleId, hasRoleIdChanged: false };
    }
    // handleActions must be called for both new and existing users so that
    // checkValidations (fired on save) is handled and date/form validation errors
    // are correctly registered before any save API calls are made.
    this.handleActions();
  }
  fetchLoggedInUser() { // IN CASE IF ISC MANAGER LOGS IN AND CREATES AN ISC
    this.usersService.getServicesUserById(this.commonService.getUserId()).subscribe({
      next: (res: any) => {
        this.loggedInUser = res?.result;
        this.isAdminLoggedIn = this.loggedInUser?.role == UserRoles.salesAdmin || this.loggedInUser?.role == UserRoles.administratorRole;
        this.isISCManagerLoggedIn = this.loggedInUser?.role == UserRoles.iscManager;
      }
    })
  }
  resetAdditionalServiceDepartmentsAPI() {
    this.additionalServiceDeptsData.map(m => {
      m.isChecked = false
      return m;
    })
  }
  getServicesData(callback?: () => void) {
    let id = this.source == UPEnums.SourceMyProfile ? '' : this.userProfile?.[UPServiceFields.userId];
    let apis = [
      this.usersService.getRoles(Applications.RimsService, this.source == UPEnums.SourceMyProfile ? 'myProfile' : 'userProfile').pipe(catchError(error => of(error))),
      this.usersService.getPayViaList().pipe(catchError(error => of(error))),
      this.usersService.getSalesPartsOfficesList().pipe(catchError(error => of(error))),
      // this.usersService.getAllEmployeeDetails(Applications.RimsService).pipe(catchError(error => of(error))),
      this.usersService.getServiceDepartmentsByAppName(id, Applications.RimsService).pipe(catchError(error => of(error)))
    ];
    apis.push(this.usersService.getBusinessLogoUrlById(this.getFieldValue(UPServiceFields.userId)).pipe(catchError(error => of(error))));
    apis.push(this.usersService.getServiceEmployees().pipe(catchError(error => of(error)))); 
    if (this.isCreatingNewUser) { // Create NEW User
    } else {
      apis.push(this.usersService.getServicesUserById(id).pipe(catchError((error: any) => of(error))));
    }


      this.fetchRemainingAPIs(apis, callback);
    // }).catch((err: any) => {
    //   this.fetchRemainingAPIs(apis, callback);
    // });

  }
  fetchRemainingAPIs(apis: any, callback?) {
    forkJoin(apis)
      .subscribe({
        next: (responses: any) => {
          this.rolesData = responses[0]?.result ?? [];
          if(this.commonService.getUSER()?.role === UserRoles.iscManager) {
            //if logged in user is an isc manager ? passed
            if (responses[6]?.result?.role != UserRoles.iscManager) {
              // if selected profile is not of an isc manager? passed
              // remove the isc manager role as isc manager shall not be allowed to create ISC Manager profiles
              const i = this.rolesData.findIndex(fi => fi.role === UserRoles.iscManager);
              this.rolesData.splice(i, 1);
            }
          }
          this.payViaData = responses[1]?.result ?? [];
          this.partsOfficeData = responses[2]?.result ?? [];
          this.additionalServiceDeptsData = JSON.parse(JSON.stringify(responses[3]?.result ?? []));
          this.serviceDeptsDataDDL = JSON.parse(JSON.stringify(responses[3]?.result ?? []));
          this.serviceDeptsDataDDL.map(m => {
            m.description = m?.serviceDepartment + " - " + m?.description
            return m;
          })
          responses[5]?.result?.map(m => {
            m.employeeIdDesc = m?.employeeId + " - " + m?.employeeName;
            return m;
          });
          this.employeeIdsData = responses[5]?.result ?? [];
          this.employeeIdsDataSource = responses[5]?.result ?? [];
          this.pictureURL = responses[4]?.result?.pictureURL ?? '';
          // const filteredSDs = this.additionalServiceDeptsData.filter((sd: any) => sd.isChecked).forEach((csd: any) => {
          //   const
          // });
          // this.serviceForm.controls[UPServiceFields.additionalServiceDept].setValue();

          if (!this.isCreatingNewUser) {
            responses[6]?.result && this.serviceForm.patchValue(responses[6]?.result ?? []);
            this.sendProfileDataToParent.emit({ section: UPEnums.ServicesFormData, data: responses[6]?.result ?? {} });
            this.usersService.setFormsInUPService('service', this.serviceForm.get(UPServiceFields.isEnabled).value ? this.serviceForm : null);

            responses[6]?.result['iscCode']  && responses[6]?.result['iscBPName'] && this.serviceForm.controls[UPServiceFields.iscCode].setValue(responses[6]?.result['iscCode'] + " - " + responses[6]?.result['iscBPName']);
            this.serviceForm.controls[UPServiceFields.iscCode].updateValueAndValidity();
            if(responses[6]?.result?.['lnEmployeeName']?.length > 0 && responses[6]?.result?.['employeeId']?.length > 0) {
              // this.serviceForm.controls[UPServiceFields.employeeId].setValue(responses[6]?.result['employeeId'] + " - " + responses[6]?.result['lnEmployeeName']);
              if (this.employeeIdsData.findIndex(fi => fi.employeeId === responses[6]?.result['employeeId']) == -1) {
             // console.log("NOT FOUND")
                this.employeeIdsData.push({ employeeId: responses[6]?.result['employeeId'], employeeName: responses[6]?.result['lnEmployeeName'], employeeIdDesc: responses[6]?.result['employeeId'] + " - " + responses[6]?.result['lnEmployeeName'] });
              } else {
             // console.log("FOUND")
                this.employeeIdsData.map(m => { if (m.employeeId === responses[6]?.result['employeeId']) { m.employeeIdDesc = m.employeeId + " - " + responses[6]?.result['lnEmployeeName']; } });
                this.employeeIdsDataSource.map(m => { if (m.employeeId === responses[6]?.result['employeeId']) { m.employeeIdDesc = m.employeeId + " - " + responses[6]?.result['lnEmployeeName']; } });
              }
              this.serviceForm.controls[UPServiceFields.employeeId].updateValueAndValidity();
            }
            
            this.deSplitServiceDepartmentValue(responses[6]?.result?.[UPServiceFields.serviceDept]);
            if (!this.getFieldValue(UPServiceFields.serviceDept)) { 
              this.serviceForm.get(UPServiceFields.serviceDept).enable();
              this.sdDDL?.clear();
            } else { 
              this.serviceForm.get(UPServiceFields.serviceDept).disable(); 
              const deptToRemoveFromAdditionalServiceDepts = this.getFieldValue(UPServiceFields.serviceDept);
              const indexToRemove = this.additionalServiceDeptsData.findIndex(fi => fi.serviceDepartment == deptToRemoveFromAdditionalServiceDepts);
              indexToRemove != -1 && (this.additionalServiceDeptsData.splice(indexToRemove, 1));
            } 
            let depts = '';
            (this.additionalServiceDeptsData as any[]).forEach((sd: any) => {
              sd?.isChecked && (depts += `${sd?.serviceDepartment},`);
            });
            this.serviceForm.controls[UPServiceFields.additionalServiceDept].setValue(depts);

            this.initiallyHasNoEmployeeId = (!this.getFieldValue(UPServiceFields.employeeId) && this.source == UPEnums.SourceUser);
            this.isSectionEnabled = this.source == UPEnums.SourceMyProfile ? true : this.serviceForm.controls?.[UPServiceFields.isEnabled].value;
            // this.serviceEnableCb && (this.serviceEnableCb.checked = (!!this.serviceForm.get(UPServiceFields.role).value && !!this.serviceForm.get(UPServiceFields.roleId).value && this.isSectionEnabled));
            // this.serviceEnableCb.refresh();
            this.userProfile = responses[6]?.result ?? [];
            this.employeeId = responses[6]?.result?.[UPServiceFields.employeeId];
            // !!this.employeeId && this.serviceForm.controls[UPServiceFields.employeeId].disable();
            // this.employeeId && this.employeeIdsData.push({ employeeId: this.employeeId });
            this.servicePreferencesConfig.roleId = this.userProfile?.roleId;
            this.servicePreferencesConfig.userId = this.userProfile?.userId;
            // this.action.next({ action: 'roleChangedOrLoaded', data: this.userProfile?.roleId });
          }
          // this.expandSectionWithDelay();
          this.loadPermissions();
          this.cdRef.markForCheck();

          callback?.();
        },
        error: (err: any) => {
          callback?.();
          // this.expandSectionWithDelay();
        },
      });
  }
  assignDefaultFSTValues() {
    if(this.serviceForm.get(UPServiceFields.role).value === UserRoles.fst) {
      !this.serviceForm.get(UPServiceFields.laborType).value && this.serviceForm.controls[UPServiceFields.laborType].setValue('HRA');
      !this.serviceForm.get(UPServiceFields.laborTask).value && this.serviceForm.controls[UPServiceFields.laborTask].setValue('001');
      !this.serviceForm.get(UPServiceFields.laborCCMP).value && this.serviceForm.controls[UPServiceFields.laborCCMP].setValue('403');
      !this.serviceForm.get(UPServiceFields.otherCCMP).value && this.serviceForm.controls[UPServiceFields.otherCCMP].setValue('35');
      !this.serviceForm.get('travelCalloutCharges').value && this.serviceForm.controls['travelCalloutCharges'].setValue('402');
      !this.serviceForm.get(UPServiceFields.materialCCMP).value && this.serviceForm.controls[UPServiceFields.materialCCMP].setValue('101');
    }
  }
  // expandSectionWithDelay() {
  //   setTimeout(() => {
  //     this.expandServiceSection = true;
  //   }, 200);
  // }
  initForm(data?: any) {
    this.serviceForm.addControl(UPServiceFields.userId, new FormControl(this.userProfile?.[UPServiceFields.userId]));
    this.serviceForm.addControl(UPServiceFields.isEnabled, new FormControl(false));
    this.serviceForm.addControl(UPServiceFields.roleId, new FormControl(''));
    this.serviceForm.addControl(UPServiceFields.role, new FormControl(''));
    this.serviceForm.addControl(UPServiceFields.startDate, new FormControl(''));
    this.serviceForm.addControl(UPServiceFields.endDate, new FormControl(''));
    this.serviceForm.addControl(UPServiceFields.employeeId, new FormControl(''));
    this.serviceForm.addControl(UPServiceFields.addressCode, new FormControl(''));
    this.serviceForm.addControl(UPServiceFields.iscCode, new FormControl(''));
    this.serviceForm.addControl(UPServiceFields.iscSupplierCode, new FormControl(''));
    this.serviceForm.addControl(UPServiceFields.payViaInt, new FormControl());
    this.serviceForm.addControl(UPServiceFields.partsSalesOfficeInt, new FormControl());
    this.serviceForm.addControl(UPServiceFields.mobile, new FormControl(''));
    this.serviceForm.addControl(UPServiceFields.email, new FormControl(''));
    this.serviceForm.addControl(UPServiceFields.serviceDept, new FormControl(''));
    this.serviceForm.addControl(UPServiceFields.additionalServiceDept, new FormControl(''));
    this.serviceForm.addControl(UPServiceFields.warehouse, new FormControl(''));
    this.serviceForm.addControl(UPServiceFields.serviceManager, new FormControl(''));
    this.serviceForm.addControl(UPServiceFields.iscManager, new FormControl(''));
    this.serviceForm.addControl(UPServiceFields.serviceCar, new FormControl(''));
    this.serviceForm.addControl(UPServiceFields.laborType, new FormControl('HRA'));
    this.serviceForm.addControl(UPServiceFields.laborTask, new FormControl('001'));
    this.serviceForm.addControl(UPServiceFields.laborCCMP, new FormControl('403'));
    this.serviceForm.addControl(UPServiceFields.materialCCMP, new FormControl('101'));
    this.serviceForm.addControl(UPServiceFields.otherCCMP, new FormControl('35'));
    this.serviceForm.addControl('travelCalloutCharges', new FormControl('402'));
    this.serviceForm.addControl(UPServiceFields.t1LaborRate, new FormControl(0));
    this.serviceForm.addControl(UPServiceFields.t2LaborRate, new FormControl(0));
    this.serviceForm.addControl(UPServiceFields.t1CalloutRate, new FormControl(0));
    this.serviceForm.addControl(UPServiceFields.t2CalloutRate, new FormControl(0));
    this.serviceForm.addControl(UPServiceFields.mileageThreshold, new FormControl(0));
    this.serviceForm.addControl(UPServiceFields.mileageRate, new FormControl(0));
    this.serviceForm.addControl(UPServiceFields.appName, new FormControl(Applications.RimsService));
    this.serviceForm.addControl(UPServiceFields.canCompleteClaims, new FormControl(false));



    this.serviceForm.addControl(UPServiceFields.name, new FormControl(''));
    this.serviceForm.addControl(UPServiceFields.address, new FormControl(''));
    this.serviceForm.addControl(UPServiceFields.city, new FormControl(''));
    this.serviceForm.addControl(UPServiceFields.zipCode, new FormControl(''));
    this.serviceForm.addControl(UPServiceFields.state, new FormControl(''));
    this.serviceForm.addControl(UPServiceFields.country, new FormControl(''));
    this.userId = this.serviceForm?.controls[UPServiceFields.userId].value ?? '';

    this.serviceForm.get(UPServiceFields.isEnabled).valueChanges.subscribe((val) => {
      val && this.serviceEnableCb && (this.serviceEnableCb.checked = val);
    });
    
    [UPServiceFields.payViaInt, UPServiceFields.partsSalesOfficeInt].forEach(c => {
      this.serviceForm?.controls[c]?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe({
        next: (value: any) => {
          if(value === 0) {
            c === UPServiceFields.payViaInt ? this.payViaDDL?.clear() : this.partsOfficeDDL?.clear();
          } else {
            c === UPServiceFields.payViaInt ? (this.payViaDDL && (this.payViaDDL.value = value)) : (this.partsOfficeDDL && (this.partsOfficeDDL.value = value));
          }
        }
      })
    });
  }
  isFormPresent(formName: 'service' | 'sales') {
    return this.usersService.isFormPresent(formName);
  }
  loadPermissions(
    initData: boolean = false,
    category: string = this.source == UPEnums.SourceMyProfile ? UPEnums.MPServicePermission : UPEnums.UPServicePermission,
    subCategory: string = this.source == UPEnums.SourceMyProfile ? '' : this.serviceForm.controls[UPServiceFields.role].value,
    id: string = this.userId,
    module: string = ''
  ) {
    this.usersService.apiCallStarted("loadPermissions_Service");
    let api = this.isCreatingNewUser ?
      this.usersService.getCreateProfilePermissions(category, subCategory) :
      this.usersService.getEditProfilePermissions(category, subCategory, id);
    api.subscribe({
      next: (res: any) => {
        this.PERMISSIONS = res?.result ?? [];
        this.source == UPEnums.SourceMyProfile ? this.isSectionEnabled = true : null;
        this.PERMISSIONS.map((permission: RolePermissionsModel) => {
          if (permission.ruleAction.includes('MP_')) {
            permission.ruleAction = permission.ruleAction.replace('MP_', '');
          }

          if (permission.ruleAction.includes('UP_')) {
            permission.ruleAction = permission.ruleAction.replace('UP_', '');
          }
        });
        const updateSectionData = () => {
          this.updatePagePermissions().then(() => {
            this.reloadPreferencesAgainstRole();
            this.usersService.apiCallCompleted("loadPermissions_Service");
          });
        };

        if (this.getPermission('Service_Section')?.enable) { 
          initData ? this.getServicesData(() => {
            updateSectionData();
          }) : updateSectionData();
        } else {
          this.serviceForm.get(UPServiceFields.isEnabled).disable();
          this.usersService.apiCallCompleted("loadPermissions_Service");
        }
      },
      error: (err: any) => {
        this.PERMISSIONS = [];
        this.usersService.apiCallCompleted("loadPermissions_Service");
      }
    });
  }
  reloadPreferencesAgainstRole() {
    const roleId = this.serviceForm.controls?.[UPServiceFields.roleId].value;
    if (roleId) {
      this.action.next({ action: 'roleChangedOrLoaded', data: roleId });
    }
  }
  getPermission(ruleAction: string): RolePermissionsModel {
    return this.PERMISSIONS?.find((e: RolePermissionsModel) => e.ruleAction === ruleAction)!;
  }
  updatePagePermissions(): Promise<boolean> {
    return new Promise((resolve) => {
      [
        { control: UPServiceFields.isEnabled, rule: 'Service_enable' },
        { control: UPServiceFields.startDate, rule: 'Service_startDate' },
        { control: UPServiceFields.endDate, rule: 'Service_endDate' },
        { control: UPServiceFields.employeeId, rule: 'Service_employeeId' },
        { control: UPServiceFields.iscCode, rule: 'Service_iscCode' },
        { control: UPServiceFields.iscSupplierCode, rule: 'Service_iscSuplierCode' },
        { control: UPServiceFields.payViaInt, rule: 'Service_payViaDropwon' },
        { control: UPServiceFields.partsSalesOfficeInt, rule: 'Service_partsSalesOfficesDropdown' },
        { control: UPServiceFields.mobile, rule: 'Service_mobile' },
        { control: UPServiceFields.email, rule: 'Service_email' },
        { control: UPServiceFields.serviceDept, rule: 'Service_serviceDepartment' },
        { control: UPServiceFields.additionalServiceDept, rule: 'Service_additionalServiceDeptsList' },
        { control: UPServiceFields.warehouse, rule: 'Service_warehouse' },
        { control: UPServiceFields.serviceManager, rule: 'Service_serviceManager' },
        { control: UPServiceFields.serviceCar, rule: 'Service_serviceCar' },
        { control: UPServiceFields.laborType, rule: 'Service_laborType' },
        { control: UPServiceFields.laborTask, rule: 'Service_laborTask' },
        { control: UPServiceFields.laborCCMP, rule: 'Service_laborCCMP' },
        { control: UPServiceFields.materialCCMP, rule: 'Service_materialCCMP' },
        { control: UPServiceFields.otherCCMP, rule: 'Service_otherCCMP' },
        { control: 'travelCalloutCharges', rule: 'Service_otherCCMP' },
        { control: UPServiceFields.t1LaborRate, rule: 'Service_T1LaborRate' },
        { control: UPServiceFields.t2LaborRate, rule: 'Service_T2LaborRate' },
        { control: UPServiceFields.t1CalloutRate, rule: 'Service_T1CalloutRate' },
        { control: UPServiceFields.t2CalloutRate, rule: 'Service_T2CalloutRate' },
        { control: UPServiceFields.mileageThreshold, rule: 'Service_mileageThreshold' },
        { control: UPServiceFields.mileageRate, rule: 'Service_mileageRate' },
      ]
        .forEach((e) => { this.updateUIElement(e.control, e.rule) });
      // this.updateAddressesGridColumns();
      // this.SDsColumns.findIndex(e ==)
      // this.updateAddressesGridToolbar();
      setTimeout(() => {
        this.cdRef.markForCheck();
        resolve(true);
      }, 200);

    });
  }
  updateUIElement(control: string, rule: string) {
    setTimeout(() => {
      const RULE = this.getPermission(rule);
    if (!RULE) {
      const  r = JSON.parse(JSON.stringify(this.getPermission('Sales_enable')));
   console.log(`Service->This permission is missing in DB: ruleAction: ${rule} & category: ${r?.category} & subCategory: ${r?.subCategory}`);
  }
    if (rule == 'Service_enable') {
      const isDisabled = (!RULE?.enable || !!RULE?.readOnly || !this.userId || this.usersService.getUserGlobbayDisabled());
      isDisabled ?
        this.serviceForm.controls[control].disable() :
        this.serviceForm.controls[control].enable();
      (!!RULE?.required && !!RULE?.visible && !!this.userId) ?
        this.serviceForm.controls[control].setValidators(Validators.required) :
        this.serviceForm.controls[control].setValidators([]);
    } else {
      if (!RULE?.enable || !!RULE?.readOnly || !this.isSectionEnabled) {
        this.serviceForm.controls[control].disable();
      } else {
        this.serviceForm.controls[control].enable();
      }
      if (!!RULE?.required && !!RULE?.visible) {
        this.serviceForm.controls[control].setValidators(Validators.required);
        (rule === 'Service_payViaDropwon' || rule === 'Service_partsSalesOfficesDropdown') && this.serviceForm.controls[control].setValidators([Validators.required, Validators.min(1)]);
      } else {
        this.serviceForm.controls[control].removeValidators(Validators.required);
        (rule === 'Service_payViaDropwon' || rule === 'Service_partsSalesOfficesDropdown') && this.serviceForm.controls[control].setValidators([]);
      }
    }
    this.serviceForm.controls[control].updateValueAndValidity();
    }, 1500);
    // const RULE = this.getPermission(rule);
    // (!RULE?.enable || !!RULE?.readOnly) ?
    //   this.serviceForm.controls[control].disable() :
    //   this.serviceForm.controls[control].enable();
    // (!!RULE?.required && !!RULE?.visible) ?
    //   this.serviceForm.controls[control].addValidators(Validators.required) :
    //   this.serviceForm.controls[control].removeValidators(Validators.required);
  }
  
  // Tooltip of the Service Department dropdown, from the form value (the dropdown's own text is set mid change detection: NG0100)
  serviceDeptTitle(): string | undefined {
    const value = this.serviceForm?.get(UPServiceFields.serviceDept)?.value;
    return this.serviceDeptsDataDDL.find(d => d.serviceDepartment == value)?.description;
  }
setDateToZeroZero(e: any, control: string) {
  if(e?.isInteracted && e?.value) {
    const d = (new Date(new Date(e.value).setUTCHours(12, 0, 0, 0))).toISOString();
    console.log("serviceForm ====> "+control+" ====> ", d);
    this.serviceForm.get(control).setValue(d);
  }
}
  sectionModified(e: profileModificationModel, from: string) {
    this.cdRef.markForCheck();
 // console.log("UP RIMS SERVICE: sectionModified => "+ new Date().toISOString(), from, e.section);
    if(e.section && (e.modified != null || e.modified != undefined)) {
      this.modifiedUI[e.section] = e.modified;
    } else
        if (e.reloadSection) {
          this.modifiedUI[UPEnums.ServicePreferencesData] = false;
          this.modifiedUI[UPEnums.ServicesFormData] = false;
          this.modifiedUI[UPEnums.ServicesBusinessLogo] = false;
        }
    this.profileModified.emit(e);
  }
  getFieldValue(field: string) {
    let val = this.serviceForm.controls[field]?.value;
    if (val) {
      if (REGEXES.numericValues.test(val)) {
        val = this.serviceForm.controls[field]?.value;
      } else {
        val = (this.serviceForm.controls[field]?.value as string)?.trim();
      }
    }
    return val;
  }
  // A tick or the header box: every department's isChecked from the grid's ticks, then the form value, as before.
  onDeptsSelected(event: GridRowsSelectedEvent): void {
    const ticked = new Set(event.rows.map(r => r['id']));
    this.additionalServiceDeptsData = this.additionalServiceDeptsData.map(sd => ({ ...sd, isChecked: ticked.has(sd.id) }));
    this.shownDeptTicks = this.deptTicks();
    this.shownDepts = this.additionalServiceDeptsData;
    this.shownDeptIds = this.additionalServiceDeptsData.map(sd => sd?.id).join(',');
    this.sectionModified({ modified: true, section: UPEnums.ServicesFormData }, 'onDeptsSelected');
    this.updateAdditionalServiceDeptsFormValue();
    this.cdRef.markForCheck();
  }

  private deptTicks() {
    return this.additionalServiceDeptsData.filter(sd => sd?.isChecked).map(sd => sd.id).join(',');
  }

  // The section changes additionalServiceDeptsData in several places (load, department change, ISC data): show the
  // current array and its ticks each cycle they change, and lock the boxes again when the section is turned on or off.
  ngDoCheck(): void {
    const rows = this.additionalServiceDeptsData ?? [];
    const ticks = this.deptTicks();
    const ids = rows.map(sd => sd?.id).join(',');
    if (rows === this.shownDepts && ids === this.shownDeptIds && ticks === this.shownDeptTicks && this.isSectionEnabled === this.shownDeptsEnabled) return;
    this.shownDeptIds = ids;
    this.shownDepts = rows;
    this.shownDeptTicks = ticks;
    this.shownDeptsEnabled = this.isSectionEnabled;
    this.deptRows.set(SERVICE_DEPTS_URL, LocalRowsGridApi.schema([['id', 'int'], ['serviceDepartment', 'varchar'], ['description', 'varchar']]),
      rows.map(sd => ({ id: sd.id, serviceDepartment: sd.serviceDepartment, description: sd.description })));
    this.deptsGrid?.refresh({ keepScroll: true });
    this.tickDepts();
  }

  private tickDepts() {
    const grid = this.deptsGrid;
    queueMicrotask(() => grid?.setCheckedKeys(this.additionalServiceDeptsData.filter(sd => sd?.isChecked).map(sd => sd.id), { emit: false }));
  }
  updateAdditionalServiceDeptsFormValue() {
      let depts = [];
      this.additionalServiceDeptsData.forEach(sd => sd?.isChecked && depts.push(sd?.serviceDepartment));
      this.serviceForm.controls[UPServiceFields.additionalServiceDept].setValue(depts.join(','));
  }
  handleActions() {
    this.serviceForm.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((changes: any) => {
      // if(!changes?.serviceDept) {
      //   this.serviceForm.get(UPServiceFields.serviceDept).enable();
      // } 
    });
    if (this.actions != null) {
      this.actions
        .pipe(takeUntil(this.destroy$))
        .subscribe((ac: ISignal) => {
       // console.log(new Date().toISOString(), ac?.action);
          let hasUnsavedChanges = Object.keys(this.modifiedUI).some(key => this.modifiedUI[key] === true);
          if (ac?.action === 'reloadPermissions' && (ac?.data.category == UPEnums.UPServicePermission || ac?.data.category == UPEnums.MPServicePermission)) {
            this.loadPermissions(false, ac?.data?.category, ac?.data?.subCategory, ac?.data?.id, ac?.data?.module);
          } else
            if (ac?.action === 'checkValidations') {
                if(this.markAddressToBeCopiedToGeneral) {
                  this.copyDataToGeneral();
                  this.markAddressToBeCopiedToGeneral = false;
                }
              this.cdRef.markForCheck();
              [UPServiceFields.name, UPServiceFields.email, UPServiceFields.mobile, UPServiceFields.serviceDept].forEach((item: any) => this.removeTrailingSpaces(item));

              if (!this.isSectionEnabled) {
                // Section disabled — clear any stale invalid entries and exit.
                this.usersService.setInvalidData(false, UPEnums.ServicesFormData);
              } else if (this.usersService.invalidDataSections?.includes(UPEnums.ServicesFormData)) {
                // Dates were already flagged invalid by the General handler's
                // areDatesInvalid() which runs before this handler. Stop here so
                // we don't accidentally clear that flag below.
                return;
              } else if (hasUnsavedChanges) {
                // Section enabled + has pending changes: validate form fields.
                this.isFormSubmitted = true;
                this.serviceForm.markAllAsTouched();
                Object.values(this.serviceForm.controls).forEach((c: FormControl) => {
                  c.enable();
                  c.markAsTouched();
                  c.updateValueAndValidity();
                });
                if (this.serviceForm.invalid || !this.isMobileNumberValid || !this.isEmailAddressValid
                    || (this.isFormSubmitted && this.isISCManagerRequired && !this.serviceForm.controls[UPServiceFields.iscManager]?.value)) {
                  this.usersService.setInvalidData(true, UPEnums.ServicesFormData);
                  this.commonService.showNotification('info', 'RIMS Service: Please enter valid data!');
                } else if (this.isRoleChanged) {
                  this.usersService.setInvalidData(true, UPEnums.ServicesFormData);
                  this.commonService.showConfirmation('You are changing the role for this user, are you sure to do that?', 'Yes', 'No', 'Service')
                    .then((res: any) => {
                      if (res.isConfirmed) {
                        this.usersService.setInvalidData(false, UPEnums.ServicesFormData);
                        this.usersService.hitSaveAll.next(true);
                      }
                    });
                } else {
                  this.usersService.setInvalidData(false, UPEnums.ServicesFormData);
                }
              } else {
                // Section enabled but no unsaved changes — clear any stale errors.
                this.usersService.setInvalidData(false, UPEnums.ServicesFormData);
              } 
            } else if (ac?.action === 'saveAll' && hasUnsavedChanges) {
              if (UserProfileService.invalidDataCount <= 0) {
                let depts = this.serviceForm.controls[UPServiceFields.additionalServiceDept].value;
                if (depts.charAt(depts.length - 1) == ',') { depts = depts.slice(0, depts.length - 1); }
                this.serviceForm.controls[UPServiceFields.additionalServiceDept]?.setValue(depts);

                const saveLogo = this.modifiedUI[UPEnums.ServicesBusinessLogo] === true;
                if (this.modifiedUI[UPEnums.ServicesFormData] === true) {
                  this.saveProfile();
                }

                if (this.modifiedUI[UPEnums.ServicePreferencesData] === true) {
                  this.action.next(ac);
                }

                const saveISCLogo = () => {
                  if(this.serviceForm.get(UPGeneralFields.userId).value) {
                  this.usersService.apiCallStarted(UPEnums.ServicesBusinessLogo);
                  this.usersService.saveBusinessLogoUrlById({
                    userId: this.serviceForm.get(UPGeneralFields.userId)?.value,
                    pictureURL: this.pictureURL
                  }).subscribe({
                    next: (res: any) => {
                      // this.commonService.showNotification('info', res?.message);
                        this.usersService.apiMessages.push({
                          isSuccessfull: true,
                          message:  res?.message
                        });
                      this.sectionModified({modified: false, section: UPEnums.ServicesBusinessLogo }, 'saveISCLogo');
                      this.usersService.apiCallCompleted(UPEnums.ServicesBusinessLogo);
                    },
                    error: (err: any) => {
                      // this.commonService.showNotification('error', err?.error?.message);
                        this.usersService.apiMessages.push({
                          isSuccessfull: false,
                          message:  err?.error?.message
                        });
                      this.usersService.apiCallCompleted(UPEnums.ServicesBusinessLogo);
                    }
                  });
                }
              }
                
                saveLogo && saveISCLogo();
              }
            }
        });
    }
  }
  getMaxED() {
    const sdservice = this.serviceForm.get(UPServiceFields.startDate).value || '';
    let maxDate = null;
    // (this.usersService.getMinEndDate() && this.usersService.getMinEndDate() > sdservice) ? (maxDate = this.usersService.getMinEndDate()) : (maxDate = sdservice);
    maxDate = sdservice;
    return maxDate;
  }
  checkDatesFor(dateFor: 'SD' | 'ED') {
    const datesValidations = this.usersService.checkDatesFor('service', dateFor);
    !this.isSectionEnabled && (datesValidations.isInvalid = false);
    return datesValidations;
  }
  private droSetupUserId(): string {
    return this.userId || (this.source == UPEnums.SourceMyProfile ? this.commonService.getUserId() : '');
  }

  loadDroSetup() {
    const id = this.droSetupUserId();
    this.droSetup = null;
    if (!id) return;
    // 403 / 404: not rendered for this editor or this user (8.1.1).
    this.droApi.setupPermission(id).subscribe({
      next: p => {
        this.droSetup = p.visible ? p : null;
        this.droSetupValue = p.canSetupDroForms;
        this.droSetupChanged = false;
        this.cdRef.markForCheck();
      },
      error: () => { this.droSetup = null; this.cdRef.markForCheck(); },
    });
  }

  onDroSetupChange(checked: boolean) {
    this.droSetupValue = checked;
    this.droSetupChanged = true;
    this.sectionModified({ modified: true, section: UPEnums.ServicesFormData }, 'html-canSetupDroForms change');
  }

  private saveDroSetup() {
    const id = this.droSetupUserId();
    if (!this.droSetupChanged || !this.droSetup?.editable || !id) return;
    this.usersService.apiCallStarted('saveDroSetupPermission');
    this.droApi.saveSetupPermission(id, this.droSetupValue).subscribe({
      next: p => { this.droSetupChanged = false; this.droSetupValue = p.canSetupDroForms; this.usersService.apiCallCompleted('saveDroSetupPermission'); this.cdRef.markForCheck(); },
      error: e => {
        this.usersService.apiMessages.push({ isSuccessfull: false, message: DroApiService.message(e, '"Can Setup DRO Forms" could not be saved.') });
        this.usersService.apiCallCompleted('saveDroSetupPermission');
      },
    });
  }

  saveProfile() {
    this.modifiedUI[UPEnums.ServicesFormData] = false;
    this.usersService.apiCallStarted("saveSeviceProfile");
    let serviceDeptValue: string = this.serviceForm.get(UPServiceFields.serviceDept)?.value;
    this.serviceForm.get(UPServiceFields.serviceDept)?.setValue(serviceDeptValue?.split(' ')[0]); // save the code only for Service dept,
    
    let iscCodeValue: string = this.serviceForm.get(UPServiceFields.iscCode)?.value;
    this.serviceForm.get(UPServiceFields.iscCode)?.setValue(iscCodeValue?.split(' ')[0]); // save the code only for Service dept,
    this.serviceForm.get(UPServiceFields.employeeId)?.setValue(this.getFieldValue(UPServiceFields.employeeId)?.split(' ')[0]); // save the code only for Service dept,

    this.nullCheckPayload();
    // this.serviceForm.removeControl(UPServiceFields.address);
    // this.serviceForm.removeControl(UPServiceFields.name);
    // this.serviceForm.removeControl(UPServiceFields.city);
    // this.serviceForm.removeControl(UPServiceFields.country);
    // this.serviceForm.removeControl(UPServiceFields.state);
    // this.serviceForm.removeControl(UPServiceFields.zipCode);
    const empId = this.serviceForm.get(UPServiceFields.employeeId); // avoid null value in payload
    !empId.value && empId.setValue(''); // avoid null value in payload
    let payload = {
      ...this.serviceForm.getRawValue(),
      userId: this.userId
    };
          
      payload.startDate = payload?.startDate != null && typeof payload.startDate == 'object' ? payload.startDate?.toISOString()?.split('Z')[0] : payload?.startDate;
      payload.endDate = payload?.endDate != null && typeof payload.endDate == 'object' ? payload.endDate?.toISOString()?.split('Z')[0] : payload?.endDate;
    let iscMgr = this.serviceForm.get(UPServiceFields.iscManager);
    if (this.isISCManagerLoggedIn) {
      payload[UPServiceFields.iscManager] = this.commonService.getUserId();
      iscMgr.setValue(this.commonService.getUserId());
    }
    const splitted = iscMgr.value.split(" ")[0];
    splitted && iscMgr.setValue(splitted);
    payload[UPServiceFields.iscManager] = iscMgr.value;
    payload[UPServiceFields.payViaInt] = payload[UPServiceFields.payViaInt] || 0;
    // payload[UPServiceFields.serviceDept] = ''; // resets the service department value, just for unit testing
    this.usersService.saveServiceSection(payload).subscribe({
      next: (res: any) => {
        // this.showISCManagerHyperlink = false;
        this.employeeId = res?.result?.[UPServiceFields.employeeId];
        this.isRoleChanged = false;
        this.serviceForm.patchValue(res?.result);
        this.sendProfileDataToParent.emit({ section: UPEnums.ServicesFormData, data: res?.result ?? {} });
        this.usersService.setFormsInUPService('service', this.serviceForm.get(UPServiceFields.isEnabled).value ? this.serviceForm : null);
        
        this.serviceForm.controls[UPServiceFields.iscCode].setValue(res?.result['iscCode'] + " - " + res?.result['iscBPName']);
        this.serviceForm.controls[UPServiceFields.iscCode].updateValueAndValidity();

        this.employeeIdsDataSource = this.employeeIdsData.filter((e: any) => e.employeeId === this.employeeId);
        
        this.deSplitServiceDepartmentValue(res?.result?.[UPServiceFields.serviceDept]);
        
        if (!this.getFieldValue(UPServiceFields.serviceDept)) { 
              this.serviceForm.get(UPServiceFields.serviceDept).enable();
              this.sdDDL?.clear();
            } else { 
              this.serviceForm.get(UPServiceFields.serviceDept).disable(); 
            } 



        // !!this.employeeId && this.serviceForm.controls[UPServiceFields.employeeId].disable();
        this.sectionModified({ modified: false, section: UPEnums.ServicesFormData, updatedPermissiosParameters: { category: this.source == UPEnums.SourceMyProfile ? UPEnums.MPServicePermission : UPEnums.UPServicePermission, id: this.source == UPEnums.SourceMyProfile ? '' : this.userId } }, 'saveProfile');
        // this.commonService.showNotification('info', res.message);
        this.usersService.apiMessages.push({
          isSuccessfull: true,
          message:  res?.message
        });
        this.isFormSubmitted = false;
        this.loadPermissions(true);
        this.saveDroSetup();
        this.modifiedUI[UPEnums.ServicesFormData] = false;
        this.usersService.apiCallCompleted("saveSeviceProfile");
      },
      error: (err: any) => {
        this.modifiedUI[UPEnums.ServicesFormData] = true;
        // this.commonService.showNotification('error', err?.error?.message);
                        this.usersService.apiMessages.push({
                          isSuccessfull: false,
                          message:  err?.error?.message
                        });
        this.usersService.apiCallCompleted("saveSeviceProfile");
      },
    });
  }
  deSplitServiceDepartmentValue(value: string) {
    const serviceDeptCode = value?.split(' ')[0] ?? '';
    this.serviceForm.controls[UPServiceFields.serviceDept].setValue(serviceDeptCode);
  }
  nullCheckPayload() {
    [UPServiceFields.payViaInt, UPServiceFields.partsSalesOfficeInt, UPServiceFields.mileageRate, UPServiceFields.mileageThreshold, UPServiceFields.t2CalloutRate, UPServiceFields.t1CalloutRate, UPServiceFields.t2LaborRate, UPServiceFields.t1LaborRate].forEach(c => {
      (this.serviceForm.get(c).value === null || this.serviceForm.get(c).value === '') && this.serviceForm.get(c).setValue(0)
    });
    
      !this.serviceForm.get(UPServiceFields.laborTask).value && this.serviceForm.controls[UPServiceFields.laborTask].setValue('');
      !this.serviceForm.get(UPServiceFields.laborCCMP).value && this.serviceForm.controls[UPServiceFields.laborCCMP].setValue('');
      !this.serviceForm.get(UPServiceFields.otherCCMP).value && this.serviceForm.controls[UPServiceFields.otherCCMP].setValue('');
      !this.serviceForm.get('travelCalloutCharges').value && this.serviceForm.controls['travelCalloutCharges'].setValue('');
      !this.serviceForm.get(UPServiceFields.materialCCMP).value && this.serviceForm.controls[UPServiceFields.materialCCMP].setValue('');
      
      [UPServiceFields.laborType,
      UPServiceFields.laborTask,
      UPServiceFields.iscCode,
      UPServiceFields.iscManager,
      UPServiceFields.iscSupplierCode,
      ].forEach((c) => !this.serviceForm.get(c).value && this.serviceForm.get(c).setValue(''));
    }
  copyDataToGeneral() {
    // this.commonService.showConfirmation(`Do you want to copy ${this.isISCManagerLoggedIn ? 'your' : 'the'} mobile phone, email and address to the general section.`).then((res: any) => {
    //   if (res.isConfirmed) {
            let addresses = this.usersService.getGeneralAddressCodes();
            const isAddressAlreadyPresent = this.newAddress?.addressCode && addresses.some(generalAddress => this.newAddress?.addressCode && (generalAddress?.addressCode == this.newAddress?.addressCode));
        this.usersService.copyDataToGeneral.next({
          // [UPGeneralFields.primaryEmail]: this.getFieldValue(UPServiceFields.email),
          // [UPGeneralFields.primaryMobile]: this.getFieldValue(UPServiceFields.mobile),
          "newAddress": !isAddressAlreadyPresent && this.newAddress
        });
        this.newAddress = null;
        this.mobileEmailAddressAssignedToGeneralOnce = true;
    //   }
    // })
  }
  viewEmployees(type?: 'ISC' | 'ISCManager') {
    this.advancedSearchEmployeesConfigurations.filterParentId = null;
    this.showAdvancedEmployeesSearchPopup = true;
    if (type == 'ISC') {
      this.advancedSearchEmployeesConfigurations.fetchIdsFor = 'service-isc-employees';
      this.advancedSearchEmployeesConfigurations.filterParentId = this.serviceForm?.controls[UPServiceFields.userId]?.value;
      this.advancedSearchEmployeesConfigurations.popupTitle = "View ISC Employees";
    } else if (type == 'ISCManager') {
      this.advancedSearchEmployeesConfigurations.fetchIdsFor = 'service-isc-managers';
      this.advancedSearchEmployeesConfigurations.popupTitle = "ISC Managers";
    } else {
      this.advancedSearchEmployeesConfigurations.fetchIdsFor = 'service-employeeIds';
      this.advancedSearchEmployeesConfigurations.popupTitle = "Advanced Employees Search";
    }
  }
  removeTrailingSpaces(control: any): void {
    this.serviceForm.get(control)?.setValue(this.serviceForm.get(control)?.value?.trim());
  }


  getAddressOfUser(): string {
    const city = this.serviceForm.controls[UPServiceFields.city]?.value?.trim();
    const state = this.serviceForm.controls[UPServiceFields.state]?.value?.trim();
    const zip = this.serviceForm.controls[UPServiceFields.zipCode]?.value?.trim();

    return [city, state, zip].filter(Boolean).join(', ');
  }
  get isEmailAddressValid() {
    let email = this.serviceForm.controls[UPServiceFields.email].value;
    return email ? (/^\w+.*@\w+([\.-]?\w+)*(\.\w{2,16})+$/.test(this.serviceForm.controls[UPServiceFields.email].value)) : true;
  }
  get isMobileNumberValid() {
    const phoneNumberRegex = /^[\d-()+#]{10,20}$/;
    let mobileNo = this.serviceForm.controls[UPServiceFields.mobile].value;
    let check: boolean = mobileNo ? this.isFormSubmitted && mobileNo.replace(/[-()+#]/g, "")?.length > 9 && phoneNumberRegex.test(mobileNo) : true;
    return check;
  }
  clearPersistence() {
    if (this.getPermission('Service_resetPreferencesButton')?.enable && this.isSectionEnabled) {
      this.commonService.showConfirmation('Are you sure to clear persistence?')
        .then(res => {
          if (res?.isConfirmed) {
            this.usersService.apiCallStarted("clearPersistence");
            this.usersService.clearPersistence(this.serviceForm.controls[UPServiceFields.userId]?.value, Applications.RimsService)
              .subscribe({
                next: (res: any) => {
                  this.usersService.apiCallCompleted("clearPersistence");
                  this.commonService.showNotification('info', res.message);
                },
                error: (err: any) => {
                  this.commonService.showNotification('error', err?.error?.message);
                  this.usersService.apiCallCompleted("clearPersistence");
                },
              });
          }
        });
    }
  }

  onEnableSectionCheckboxChange(e: any) {
    if (this.serviceEnableCb?.checked) {
      this.enableDisableApp(true);
    } else {
      let hasUnsavedChanges = Object.keys(this.modifiedUI).some(key => this.modifiedUI[key] === true);
      if(hasUnsavedChanges) {
        this.commonService.showConfirmation("Any unsaved data will be lost, are you sure to disable this user on service application?")
          .then((res: any) => {
            if (res?.isConfirmed) {
              this.enableDisableApp(false);
              this.sectionModified({ reloadSection: 'service' }, 'onEnableSectionCheckboxChange disable with unsaved changes - not modified');
            } else {
              this.serviceEnableCb.checked = true;
            }
          });
      } else {
        this.commonService.showConfirmation("Are you sure to disable this user on service application?")
          .then((res: any) => {
            if (res?.isConfirmed) {
              this.enableDisableApp(false);
            } else {
              this.serviceEnableCb.checked = true;
            }
          });
      }
    }
  }
  enableDisableApp(toggle: boolean) {
    this.usersService.apiCallStarted('servicesEnableCb');
    this.usersService.setFormsInUPService('service', toggle ? this.serviceForm : null);
    this.usersService.enableDisableApplication(this.userId, Applications.RimsService, toggle).subscribe({
      next: (res: any) => {
        this.usersService.apiCallCompleted('servicesEnableCb');
        
        if ((res?.message as string)?.includes('assigned')) {
          this.commonService.showNotification("warning", res?.message);
          this.serviceEnableCb && (this.serviceEnableCb.checked = !toggle);
        } else {
        let hasUnsavedChanges = Object.keys(this.modifiedUI).some(key => this.modifiedUI[key] === true);
        // reload if disabling and has unsaved changes, will reset UI because changes were not saved.
        this.sectionModified({ reloadSection: "service" }, 'enableDisableApp disable with unsaved changes - modified');
        // reload if enabling, we want the latest details of the section to be loaded when enabling the section.
        this.sectionModified({ reloadSection: "service" }, 'enableDisableApp enable - modified');
        this.isSectionEnabled = toggle;
        }
      },
      error: (err: any) => {
        this.usersService.apiCallCompleted('servicesEnableCb');
        this.isSectionEnabled = !toggle;
        this.serviceEnableCb && (this.serviceEnableCb.checked = !toggle);
        this.commonService.showNotification("error", err?.error?.message);
      }
    });
  }
  get isISCManagerRequired() {
    const upRole = this.serviceForm.controls[UPServiceFields.role].value;
    return upRole == UserRoles.isc || upRole == UserRoles.IscSupervisor;
  }
  get hasAddress(): boolean {
    return !!(
      this.getFieldValue(this.UPServiceFields.address) ||
      this.getFieldValue(this.UPServiceFields.name) ||
      this.getAddressOfUser() ||
      this.getFieldValue(this.UPServiceFields.country)
    );
  }


  
  get isProfilePictureDeletable() {
    return (!!this.pictureURL && this.isSectionEnabled);
  }

  
    beforeFileUpload(args: any) {
      this.usersService.apiCallStarted("beforeFileUpload");
      if (args.fileData.name.length > 250) {
        this.commonService.showNotification("error", "File name too long")
        args.cancel = true;
        this.usersService.apiCallCompleted("beforeFileUpload");
      } else
        if (args.fileData.size > 4300000) {
          this.commonService.showNotification("error", "Image size cannot be greater than 4mb")
          args.cancel = true;
          this.usersService.apiCallCompleted("beforeFileUpload");
        } else
          if (!(['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg', 'tiff', 'tif', 'heic', 'heif', 'avif'].includes(args.fileData.type))) {
            this.commonService.showNotification("error", "Please upload a valid image file (PNG, JPG, JPEG, GIF, BMP, WEBP, SVG, TIFF, HEIC, HEIF, AVIF).")
            args.cancel = true;
            this.usersService.apiCallCompleted("beforeFileUpload");
          } else {
            this.usersService.apiCallCompleted("beforeFileUpload");
            args.currentRequest.setRequestHeader('Authorization', `Bearer ${this.authService.getToken()}`);
          }
    }
  
    clickAttachmentUpload(e: Event) {
      // this.usersService.apiCallStarted("uploadProfilePicture");
      (document.querySelector(`#logoUpload>div>div>button`) as HTMLButtonElement)
        .click();
      e.preventDefault();
      e.stopPropagation();
    }
    onFileClear(e: any): void {
      this.uploader.clearAll(); // Resets the uploader
    }
    onUploaderCreated(uploader: UploaderComponent) {
      if (uploader) {
        this.uploader = uploader;
        uploader.dropArea = document.getElementsByClassName('image-section')[0] as HTMLElement;
      }
    }
    onUploadSuccess(args: any) {
      const file = args.file;
      const response = JSON.parse(args.e.srcElement.responseText);
      if (response) {
        this.pictureURL = response.result.url;
      } else {
        console.error('Upload succeeded but URL not found in response', response.result);
      }
      this.sectionModified({modified: true, section: UPEnums.ServicesBusinessLogo },'onUploadSuccess business logo');
    }
  
    onActionComplete(args: any) {
      if (args.name === 'actionComplete' && args.fileData) {  }
    }
    
  deleteUI(ui: 'Business Logo') {
    if ((ui === 'Business Logo' && this.isProfilePictureDeletable)) {
  // console.log("Is Pic deletable?")
      this.commonService.showConfirmation(`Are you sure you want to delete ${ui}?`)
        .then((res: any) => {
          if (res?.isConfirmed) {
            this.usersService.apiCallStarted("deleteUI");
            let api: any;
            let payload: any = { userId: this.userId }
            if (ui === 'Business Logo') {
              payload['pictureURL'] = '';
              api = this.usersService.deleteUserBusinessLogoUrlById(payload);
            }
            api.subscribe({
              next: (res: any) => {
                if (ui === 'Business Logo') {
                  this.sectionModified({modified: false, section: UPEnums.ServicesBusinessLogo },'deleteUI business logo');
                  this.pictureURL = res?.result?.pictureURL;
                  this.uploader.clearAll();
                }
                this.usersService.apiCallCompleted("deleteUI");
                this.commonService.showNotification('info', res.message);
              },
              error: (err: any) => {
                this.commonService.showNotification('error', err?.error?.message);
                this.usersService.apiCallCompleted("deleteUI");
              }
            });
          }
        });
    }
  }
  
}

